import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import "./ContactPageHeader.css"; // Custom CSS for exact styling

const ContactPageHeader = () => {
  return (
    <div fluid className="ContactPageHeader-container">
      <Row className="align-items-center ContactPageHeader-row">
        <Col lg={6} md={12} className="ContactPageHeader-image-container">
          <Image
            src="https://caas.athenahealth.com/sites/default/files/styles/webp_image_style/public/2024/10/0ca38b83017e16a572ec3e6838f50d09.webp?itok=70gMWNDW"
            alt="Behavioral Health EHR"
            className="ContactPageHeader-image"
          />
        </Col>
        <Col lg={6} md={12} className="ContactPageHeader-text">
          <h6 className="ContactPageHeader-subtitle">
            Get in Touch with Myrtle Rcm
          </h6>
          <h2 className="ContactPageHeader-title" style={{ color: "white" }}>
            We’d Love to Hear From You!
          </h2>
          <p
            className="ContactPageHeader-description"
            style={{ color: "white", fontFamily: "Helvetica" }}
          >
            Feel free to fill out the contact form below, or reach out through
            any of the available methods. We're looking forward to connecting
            with you!
          </p>
        </Col>
      </Row>
    </div>
  );
};

export default ContactPageHeader;
